export default __webpack_public_path__ + "static/media/BetterMeter.ebabcf0a.svg";